import React from 'react'
import Footer from '../../components/footer/Footer'
import Navbar from '../../components/navbar/Navbar'
import EnquiryForm from './EnquiryForm'

const Enquiry = () => {
  return (
    <div>
      <Navbar />
      <EnquiryForm/>
      <Footer/>
    </div>
  )
}

export default Enquiry
